export const extendIncidents = (incidents, days = 90) => {
  function formatDate(date) {
    const year = date.getUTCFullYear();
    const month = String(date.getUTCMonth() + 1).padStart(2, '0');
    const day = String(date.getUTCDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  function splitIncident(incident) {
    const results = [];
    const start = new Date(incident.start_time);
    const end = incident.end_time ? new Date(incident.end_time) : new Date();

    const current = new Date(start);
    current.setUTCHours(0, 0, 0, 0);

    const endDate = new Date(end);
    endDate.setUTCHours(0, 0, 0, 0);

    while (current <= endDate) {
      const dayStart = new Date(current);
      const dayEnd = new Date(current);
      dayEnd.setUTCHours(23, 59, 59, 999);

      // For the first day, start_time is actual start time
      const segmentStart =
        current.getTime() === new Date(start).setUTCHours(0, 0, 0, 0)
          ? start
          : new Date(dayStart);

      // For the last day, end_time is actual end time
      const segmentEnd =
        current.getTime() === new Date(end).setUTCHours(0, 0, 0, 0)
          ? end
          : new Date(dayEnd);

      results.push({
        ...incident,
        start_time: segmentStart.toISOString(),
        end_time: segmentEnd.toISOString(),
        actual_start_time: incident.start_time,
        actual_end_time: incident.end_time,
        date: formatDate(current),
      });

      current.setUTCDate(current.getUTCDate() + 1);
    }

    return results;
  }

  // Step 1: Flatten all incidents by splitting multi-day ones
  const flattenedIncidents = [];
  incidents.forEach(incident => {
    flattenedIncidents.push(...splitIncident(incident));
  });

  const uniqueIncidents = Array.from(
    new Map(
      flattenedIncidents.map(i => [`${i.start_time}_${i.end_time}`, i])
    ).values()
  );

  // Step 2: Build a map of incidents by date
  const incidentMap = [...uniqueIncidents].reduce((acc, incident) => {
    const dateKey = incident.date;
    if (!acc[dateKey]) {
      acc[dateKey] = [];
    }
    acc[dateKey].push(incident);
    return acc;
  }, {});

  // Step 3: Generate 90-day dataset
  const finalData = [];
  const today = new Date();
  today.setUTCHours(0, 0, 0, 0);

  // eslint-disable-next-line no-plusplus
  for (let i = days - 1; i >= 0; i--) {
    const date = new Date(today);
    date.setUTCDate(date.getUTCDate() - i);
    const dateStr = formatDate(date);

    if (incidentMap[dateStr]) {
      finalData.push({
        id: incidentMap[dateStr][0].id,
        date: dateStr,
        incidents: incidentMap[dateStr].reverse(),
        severity: incidentMap[dateStr][0].severity,
      });
    } else {
      finalData.push({
        date: dateStr,
      });
    }
  }

  return finalData;
};

export function formatDate(date) {
  const year = date.getUTCFullYear();
  const month = String(date.getUTCMonth() + 1).padStart(2, '0');
  const day = String(date.getUTCDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}
